module.exports = __webpack_public_path__ + "img/loader.b109fd6c.svg";